<button *ngIf="isShow" (click)="scrollToTop()" class="back-to-top-btn">
  <span>Back to Top</span> <i class="fa fa-arrow-up"></i>
</button>
